import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCAkKekYoTWez1c2m9HyAUlCdg1Hq5jJg8",
  authDomain: "atlantic-fence-pos.firebaseapp.com",
  projectId: "atlantic-fence-pos",
  storageBucket: "atlantic-fence-pos.firebasestorage.app",
  messagingSenderId: "406323013308",
  appId: "1:406323013308:web:2c27ce4166cec3c4eb12b9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);